import { server } from '@/helpers';

export const loginServices = {
  requestOtp,
  login,
  isEmailRegistered,
};

function requestOtp({
  email,
  triggerSource,
  redirectUrl,
  signal,
}: {
  email: string;
  triggerSource: string;
  redirectUrl: string;
  signal?: AbortSignal;
}) {
  return server.request
    .get('/oauth/request-otp', { params: { email, triggerSource, redirectUrl }, signal })
    .then((response) => response.data);
}

function login({ email, code }: { email: string; code: string }, signal?: AbortSignal) {
  return server.request
    .get(`/login/otp?email=${encodeURIComponent(email)}&code=${code}`, { withCredentials: true, signal })
    .then((response) => response.data);
}

function isEmailRegistered(email: string, signal?: AbortSignal): { exists: boolean } {
  return server.request.post('/login/is-email-registered', { email }, { signal }).then((response) => response.data);
}
